import React from "react";
import LoginPage from "../auth/LoginPage";

function AllPermission({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <LoginPage />;
  }

  return children;
}

export default AllPermission;